import { useQuery } from "@tanstack/react-query";
import { api } from "./client.js";

export interface SystemStatusDto {
  accounts: {
    active: number;
    cooldown: number;
    needsRelogin: number;
    banned: number;
    working: number;
  };
  queue: {
    wait: number;
    active: number;
    delayed: number;
  };
  jobs24h: {
    success: number;
    failed: number;
    failedByClass: Array<{ errorClass: string; count: number }>;
  };
  coverageToday: Array<{ cron: string; expected: number; scraped: number }>;
  capacity: Array<{
    accountId: string;
    login: string;
    dailyRequestCount: number;
    dailyLimit: number;
    percent: number;
  }>;
}

export interface RecentFailureDto {
  id: string;
  itemId: string;
  itemDisplayName: string;
  itemKind: string;
  errorClass: string | null;
  errorMessage: string | null;
  attempt: number;
  createdAt: string;
  hasRetriedSuccessfully: boolean;
}

export function useSystemStatus() {
  return useQuery({
    queryKey: ["system-status"],
    queryFn: () => api<SystemStatusDto>("/api/system-status"),
    // Авто-обновление каждые 30с — данные в Dashboard'е должны быть «живыми».
    refetchInterval: 30 * 1000,
    staleTime: 15 * 1000,
  });
}

export function useRecentFailures(params: { limit?: number; hours?: number } = {}) {
  return useQuery({
    queryKey: ["recent-failures", params],
    queryFn: () =>
      api<{ failures: RecentFailureDto[] }>("/api/system-status/recent-failures", {
        query: { limit: params.limit, hours: params.hours },
      }),
    select: (r) => r.failures,
    staleTime: 30 * 1000,
  });
}
